<script setup lang="ts">
import { useRoute } from 'vue-router';
import { i18n } from '@/i18n';

//i18n
const t = i18n.t;
const route = useRoute();
</script>
<template>
  <div class="tab__container">
    <router-link to="/inventory-control">
      <div :class="route.path === '/inventory-control' ? 'tab__active' : 'tab__inactive'">{{ t('在庫管理') }}</div>
    </router-link>
    <router-link to="/business">
      <div :class="route.path === '/business' ? 'tab__active' : 'tab__inactive'">{{ t('発注管理') }}</div>
    </router-link>
    <router-link to="/unmanaged-business">
      <div :class="route.path === '/unmanaged-business' ? 'tab__active' : 'tab__inactive'">{{ t('未管理') }}</div>
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
.tab {
  &__container {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-gap: 10px;
    height: 30px;
  }

  &__active {
    color: $textDefault;
    height: 30px;
    border-bottom: 2px solid $semanticPrimary;
    text-align: center;
    line-height: 36px;
    font-family: Noto Sans JP;
    font-size: $fontSizeS;
    font-weight: 700;
    letter-spacing: 0em;
  }

  &__inactive {
    color: $textSecondary;
    height: 30px;
    text-align: center;
    line-height: 36px;
    font-family: Noto Sans JP;
    font-size: $fontSizeS;
    font-weight: 500;
    letter-spacing: 0em;
  }
}
</style>
